import { Type } from 'class-transformer';
import { IsIn, IsInt, IsOptional, Min, IsString } from 'class-validator';

import { FilterType } from '@vk-hr-tek/core/filter';

import { MappedFeedPostSettings } from '../../types';

const DEFAULT_LIMIT = 50;

export class GetFeedPostsFiltersDto {
  @IsIn(['posts', 'news'])
  @IsString()
  @IsOptional()
  type?: MappedFeedPostSettings['type'];

  @IsInt()
  @Min(0)
  @Type(() => Number)
  @IsOptional()
  offset = 0;

  @IsInt()
  @Min(1)
  @Type(() => Number)
  @IsOptional()
  limit = DEFAULT_LIMIT;

  filters?: FilterType;
}
